import { render } from "./Vehicle.vue?vue&type=template&id=71dbcbce"
import script from "./Vehicle.vue?vue&type=script&lang=ts"
export * from "./Vehicle.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QSeparator});
